import * as types from "../mutation-types";
import stepperFlows from "../../stepperFlow.json";
import cloneDeep from "lodash.clonedeep";

const state = {
    currentFlow: [],
    currentStep: {},
    flowMap: {},
    portfolioWarningClass: ""
};

const actions = {
    setFlow({ commit }, data) {
        const flow = cloneDeep(stepperFlows.flows[data]);
        const flowMap = [];
        flow.forEach(step => {
            const { path } = step;
            if (!flowMap[path]) {
                flowMap[path] = step;
            }
            if (step.steps) {
                const { steps } = step;
                steps.forEach(subStep => {
                    const { path } = subStep;
                    if (!flowMap[path]) {
                        flowMap[path] = subStep;
                    }
                });
            }
        });
        commit(types.SET_FLOW_MAP, flowMap);
        commit(types.SET_CURRENT_FLOW, flow);
    },
    setActiveStep({ commit }, data) {
        const flow = state.currentFlow.map(item => {
            const step = { ...item };
            const { steps } = step;
            step.active = step.path === data;
            if (steps) {
                const subSteps = [...steps];
                step.steps = subSteps.map(subStep => {
                    if (subStep.path === data) {
                        subStep.active = true;
                        step.active = true;
                    } else {
                        subStep.active = false;
                    }
                    return subStep;
                });
            }
            return step;
        });
        commit(types.SET_CURRENT_FLOW, flow);
        commit(types.SET_CURRENT_STEP, data);
    },
    setPortfolioWarningClass({ commit }, data) {
        commit(types.SET_PORTFOLIO_WARNING_CLASS, data);
    }
};

const mutations = {
    [types.SET_CURRENT_FLOW](state, data) {
        state.currentFlow = [...data];
    },
    [types.SET_CURRENT_STEP](state, data) {
        state.currentStep = { ...state.flowMap[data] };
    },
    [types.SET_FLOW_MAP](state, data) {
        state.flowMap = { ...data };
    },
    [types.SET_PORTFOLIO_WARNING_CLASS](state, data) {
        state.portfolioWarningClass = data ? "with-banner" : "";
    }
};

const getters = {
    getCurrentFlow(state) {
        return state.currentFlow;
    },
    getCurrentStep(state) {
        return state.currentStep;
    },
    getStep(key) {
        return state.flowMap[key];
    },
    getFlowMap(state) {
        return state.flowMap;
    },
    getPortfolioWarningClass(state) {
        return state.portfolioWarningClass;
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};
